window.addEventListener("DOMContentLoaded", () => {
  const topBarDesktop = document.querySelector("#top-bar");
  const topBarMobile = document.querySelector("#top-menu-mobile");
  handleExtranetLink(topBarDesktop);
  handleExtranetLink(topBarMobile);
});

/**
 * Handles changing the link of the extranet to -> etusivu if we are on an extranet page and we are logged in.
 *
 * @param {Element | null} el - The HTML element to process. If null, the function returns immediately.
 */
const handleExtranetLink = (el: Element | null) => {
  if (!el) return;
  const isExtranet = el.getAttribute("data-extranet-page") === "true";
  const isLoggedIn = el.getAttribute("data-extranet-logged-in") === "true";
  if (!isExtranet || !isLoggedIn) return;
  const link = el.querySelector(".icon-extranet a");
  if (!link) return;
  link.setAttribute("href", "/");
  link.textContent = "Etusivu";
};
